import { DialogProps, Panel, PanelProps } from "@mcleod/components";
import { ArrayUtil } from "@mcleod/core";
import { CommonDialogs } from "../CommonDialogs";

export class ReadOnlyTextAreaPanel extends Panel {
    private textarea: HTMLTextAreaElement;

    constructor(props?: Partial<PanelProps>) {
        super({
            fillHeight: true,
            fillRow: true,
            ...props
        });

        this.textarea = document.createElement("textarea");
        this.textarea.readOnly = true;
        Object.assign(this.textarea.style, {
            whiteSpace: "nowrap",
            fontFamily: "monospace",
            width: "100%",
            height: "100%",
            resize: "none",
            outline: "none",
            border: "none"
        });
        this._element.appendChild(this.textarea);
    }

    public setText(text: string) {
        this.textarea.value = text;
    }

    public static showInDialog(text: string | string[], props: Partial<DialogProps>) {
        const textArray = ArrayUtil.getAsArray(text);
        if (ArrayUtil.isEmptyArray(textArray)) {
            return;
        }

        const panel = new ReadOnlyTextAreaPanel();
        panel.setText(textArray.join("\n"));
        CommonDialogs.showDialog(panel, { width: "80vw", height: "80vh", resizable: true, ...props });
    }
}
